// extracted by mini-css-extract-plugin
export default {"outerContainer":"TeamScores_outerContainer__XSnWJ","image":"TeamScores_image__lsvpJ","teamScore":"TeamScores_teamScore__3irm5","time_text":"TeamScores_time_text__JjKTz"};